<template>
    <div>
        <navbar-sas></navbar-sas>

      <div>
        <div class="text-center mt-4">
          <h4>Ingresa tu número de importación y carga los datos faltantes</h4>
        </div>
        <div class="row mt-4">
          <div class="col-4"></div>
          <div class="col-4">
            <!-- <label class="form-label">Número de importacion</label> -->
                <input type="text" class="form-control" v-model="numImportacion" placeholder="Número de Importación">
          </div>
          <div class="col-4"></div>
        </div>
        <div>
          <div class="text-center">
            <button @click="validaImportacion" type="button" class="btn btn-primary mt-3 col-2"><i  style="color:#fffdfd;"  class="fas fa-search mr-2"></i>Buscar</button>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <div class="text-center mt-5">
          <h4>Solicitamos los siguientes documentos</h4>
        </div>

        <div class="row mt-1 mb-3">
          <div class="col-2"></div>

          <div class="col-8">
            <div class="card cardTabla">
              <div class="table-responsive">
                <table class="table text-center">
                  <thead>
                    <tr>
                      <th scope="col">Requisito</th>
                      <th scope="col">Adjuntar</th>
                      <th scope="col">Visor</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr  v-for="(result, i) in listArchivos" :key="i">
                        <!-- <div v-if="result.EstatusArchivo == '2'"> -->
                          <td v-if="result.EstatusArchivo == '2'" style="width: 290px;">{{ result.NombreArchivo }}</td>
                          <td v-if="result.EstatusArchivo == '2'" style="width: 290px;">
                              <div class="card cardxs">
                                  <div class="row fila">
                                      <div class="col-3 columnaIconoxs">
                                          <i style="color:rgb(0, 0, 0); " class="mt-3 fas fa-book-open fa-2x"></i>
                                      </div>
                                      <div class="col-9 coltxt">
                                          <h6 class="titulo">{{ result.NombreArchivo }}</h6>
                                          <input @change="onChangeFileDocs($event, result)" type="file" class="file-select"/>
                                      </div>
                                  </div>
                              </div>
                          </td>
                            <td v-if="result.EstatusArchivo == '2'" style="width: 290px;">
                                <button @click="mostrarArchivos(result.ArchivoB64)" type="button" class="btn btn-primary">
                                    <i  style="color:#fffdfd;" class=" mr-2 far fa-eye"></i>
                                    Ver
                                </button>
                            </td>
                        <!-- </div> -->
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-2"></div>
        </div>
        <div class="text-center">
            <button @click="generaNumImportacion" type="button" class="btn btn-primary mt-2 col-2 mb-5">
              <i  style="color:#fffdfd;"  class="fas fa-paper-plane mr-2"></i>
              Enviar Solicitud
            </button>
        </div>

      </div>

      
      <div class="footer text-center mt-4">
          <p class="mt-3">@Latino Seguros</p>
        </div>


        <div id="ModalVerDocumento">
          <CModal color="" :show.sync="modals.ver" :close-on-backdrop="false">
              <template #footer-wrapper><span></span></template>
              <div class="card-body p-0">
                  <iframe class="iframePdf" :src="doc" frameborder="0"></iframe>
              </div>
              <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                  <CButton @click="modals.ver = false" color="outline-secondary">
                      Cerrar
                  </CButton>
              </CCardFooter>
          </CModal>
      </div>
        <loading></loading>
        

    </div>
  
</template>

<script>
import loading from '../../componentes/ImgLoading/loading.vue';
import NavbarSas from './navbarSas.vue';
export default {
  components: { loading, NavbarSas },
    data() {
      return {
        numImportacion:"",
        doc: "",
        factura: "",
        ArchivoD: "",
        nombreArchivoD: "",
        tipoArchivoD: "",
        listArchivos: [],
        listArchivosUpload: [],
        archivoBase64Lista: [],
        listArchivosBody: [],
        resArchivos: [],
        modals: { 
            ver: false
        },
        profileId: localStorage.getItem("profileId")
      }
    },
methods: {
    async enviarSolicitud(){
      setTimeout(
          () => 
          this.$swal({
              icon: "success",
              title: "Actualizacion exitosa",
              // text: res.Prestadores[0].CveProveedor,
              showConfirmButton: true,
              background: '#fff',
              backdrop: `
                  rgba(0,0,123,0.4)
              `
          }),
          1500
        );
    },
    async validaImportacion() {
            const payload = {
            metodo: "VALIDAIMPORTACION",
            data: {
                Importacion: this.numImportacion
            },
            };
            console.log(payload);
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    console.log(res);

                    
                    this.factura = res.Factura
                    this.obtenerArchivosCargados()
                    // if(res[0].Subtotal != "") {
                    //   this.$swal({
                    //         icon: "error",
                    //         title: "# de importación: " + res[0].Subtotal,
                    //         text: res[0].Total,
                    //         showConfirmButton: true,
                    //     });
                    // }
                    
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }

    },
    async obtenerArchivosCargados() {
        this.listArchivos = [];
        const payload = {
            metodo: "PPOBTENERARCHIVOSCARGADOSIND",
            data: {
                Importacion: this.numImportacion,
                NumFactura: this.factura,
                IdTipoServicio:""
            },
            };
            console.log(payload);
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    this.listArchivos.push(...res.Archivos);
                    this.resArchivos = res;
                    console.log(res);
                    if(this.listArchivos.length == 0){
                      this.$swal({
                      icon: "error",
                      title: "No hay documentos faltantes.",
                      // text: "Número de importación:" + res.NumImportacion,
                      showConfirmButton: true,
                      background: '#fff',
                      backdrop: `
                          rgba(0,0,123,0.4)
                      `
                  }),
                  1500
                    }
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
    },
    async mostrarArchivos(base64) {
        console.log(base64);
        this.modals.ver = true
        var bin = btoa(base64);
        this.doc = 'data:application/pdf;base64,' + base64;
    },
    async generaNumImportacion() {
      // console.log(this.resArchivos);
      const payload = {
          metodo: "PPIMPORTAR",
          data: {
              Factura: this.resArchivos.Factura,
              Uuid: this.resArchivos.Uuid,
              Subtotal: this.resArchivos.Subtotal,
              RFC: this.resArchivos.RFC,
              TipoImportacion: this.resArchivos.TipoImportacion,
              TipoGasto: "36",
              ClaveProveedor: this.profileId,
              IdTipoServicio: this.resArchivos.IdTipoServicio,
              Siniestros: [
                  {
                      Siniestro: "",
                      Monto: "",
                      Existente: "",
                      Estimado: "",
                      IdCobertura: "",
                      CveCobertura: ""
                  }
              ],
              Archivos: this.listArchivosUpload
          },
      }; 
      console.log(payload);
      try {
          const response = await this.$store.dispatch("metodoPost", payload);
          console.log(response);
          if (response) {
              const res = this.$store.getters.getRespuestaREST[0];
              console.log(res);
              this.NumImportacion = res.NumImportacion;

              const promise = new Promise((resolve, _) => {
                  resolve(this.cargarDocumentos());
                  });
                  promise.then(_ => {
                    this.$swal({
                      icon: "success",
                      title: "Actualizacion exitosa",
                      text: "Número de importación: " + res.NumImportacion,
                      showConfirmButton: true,
                      background: '#fff',
                      backdrop: `
                          rgba(0,0,123,0.4)
                      `
                  }),
                  1500
                  }
              );
          }
      } 
      catch (errorE) {
          console.log(errorE);
      }
    },
    async cargarDocumentos() {
        for (let i = 0; i < this.listArchivosBody.length; i++) {

            let nombreArchivo = this.listArchivosBody[i].name.split(".")

            const base64 = await this.convertBase64(this.listArchivosBody[i])
            const payload = {
            metodo: "UPLOADFILE",
            data: {
                psBase64: base64,
                psNombreArchivo: nombreArchivo[0],
                psExtension: "." + this.listArchivosBody[i].name.split(".").pop(),
                psContentType: this.listArchivosBody[i].type,
                psIdOperacion: 5, 
            },
            };
            console.log(payload);
            
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    console.log(res);
                    // this.tipoServicio.push(...res);
                    // if(this.servicio != ""){
                    //     this.archivosTipoServicio();
                    // }
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
        }
    },
    async onChangeFileDocs(event, file) {
        this.ArchivoD = event.target.files[0];
        this.nombreArchivoD = event.target.files[0].name;
        this.tipoArchivoD = event.target.files[0].type;
        this.listArchivosBody.push(this.ArchivoD)
        
        this.archivoBase64Lista = await this.convertBase64(this.ArchivoD)

        for (let i = 0; i < this.listArchivos.length; i++) {
            
            if(file.IdArchivo == this.listArchivos[i].IdArchivo){
                this.listArchivos[i].ArchivoB64 = this.archivoBase64Lista;
            }
                    
        }
        let idbusqueda = this.listArchivosUpload.map(id => id.TipoDocumento).indexOf(file.IdArchivo)
        if (idbusqueda != -1 ) {
            //Si encontro un id repetido lo borra
            this.listArchivosUpload.splice(idbusqueda, 1)
        }

        let Archivos = {}
        Archivos = {    
            TipoDocumento: file.IdArchivo,
            NombreArchivo: this.nombreArchivoD
        }
        this.listArchivosUpload.push(Archivos)
        console.log(this.listArchivosUpload);

    },
    convertBase64(blob) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
            resolve(reader.result.split(",")[1]);
            };
        });
    },
}
}
</script>

<style>
.iframePdf {
    width: 480px;
    height: 300px;
  }
.cardxs{
    margin: 0;
}
small{
    font-size: small;
}
.file-select {
    position: relative;
    display: inline-block;
    width: 115px;
    height: 20px;
    margin-right: 20px;
    cursor: pointer;
}
  
.file-select::before {
    background-color: #fffdfd;
    color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 12px;
    content: "Carga tu archivo";
    /* text-decoration: underline rgb(0, 0, 0); */
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  html {
  min-height: 100%;
  position: relative;
}
body {
  margin: 0;
}
.titulo {
    margin: 0;
    align-content: center;
}
.footer{
    position:fixed;
    left:0px;
    bottom:0px;
    height:60px;
    width:100%;
    background:rgb(196, 196, 196);
}
#yourBtn {
  font-family: calibri;
  width: 170px;
  /* text-align: center; */
  margin-left:  20px;
  background-color: rgb(255, 255, 255);
  cursor: pointer;
}
.navbar{
    background-color: white;
    height: 90px;
}
.imagen {
    height: 50px;
}
.cardTabla{
    box-shadow: 5px 5px 5px rgb(218, 216, 216);
    border-radius: 10px;
}
.icono {
    color: #000000;
}
.columnaIcono{
    background-color: #ECE9E8;
}
.columnaIconoxs{
    background-color: #d4ddf7;
}
.fila{
    margin-left: 1px;
}
.coltxt{
    padding: 10px;
    line-height: 0; 
}
</style>